<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody, FormGroup, Label } from '@sveltestrap/sveltestrap';

  import {
    colorPrimary,
    colorSecondary,
    colorTertiary,
    companyName,
    companyUrl,
    fontBase,
    fontHeadings,
    fontWeightBase,
    fontWeightHeadings,
    iconUrl,
    logoUrl
  } from '@client/stores/brand';
</script>

<header>
  <h2>{$format('label.BRAND_WIZARD_STEP_REVIEW')}</h2>
  <p class="mb-3">
    {$format('label.BRAND_WIZARD_STEP_REVIEW_DESCRIPTION')}
  </p>
</header>

<h5 class="text-muted">{$format('label.BRAND_WIZARD_STEP_INTRO')}</h5>

<Card class="mb-3">
  <CardBody>
    <FormGroup spacing="mb-0">
      <h4>{$companyName}</h4>
      <a href={$companyUrl} target="_blank">{$companyUrl}</a>
    </FormGroup>
  </CardBody>
</Card>

<h5 class="text-muted">{$format('label.BRAND_WIZARD_STEP_COLORS')}</h5>

<Card class="mb-3">
  <CardBody>
    <div class="d-flex align-items-start flex-wrap gap-5">
      <FormGroup spacing="mb-0">
        <Label>{$format('label.BRAND_PRIMARY_COLOR')}</Label>
        <div class="swatch">
          <i style:background-color={$colorPrimary}></i>
          {$colorPrimary}
        </div>
      </FormGroup>
      <FormGroup spacing="mb-0">
        <Label>{$format('label.BRAND_SECONDARY_COLOR')}</Label>
        <div class="swatch">
          <i style:background-color={$colorSecondary}></i>
          {$colorSecondary}
        </div>
      </FormGroup>
      <FormGroup spacing="mb-0">
        <Label>{$format('label.BRAND_TERTIARY_COLOR')}</Label>
        <div class="swatch">
          <i style:background-color={$colorTertiary}></i>
          {$colorTertiary}
        </div>
      </FormGroup>
    </div>
  </CardBody>
</Card>

<h5 class="text-muted">{$format('label.BRAND_WIZARD_STEP_TYPOGRAPHY')}</h5>

<Card class="mb-3">
  <CardBody>
    <div class="d-flex align-items-start flex-wrap gap-5">
      <FormGroup spacing="mb-0">
        <Label>{$format('label.BRAND_FONT_HEADINGS')}</Label>
        <div style="font-family: {$fontHeadings}; font-size: 2rem; font-weight: {$fontWeightHeadings}">
          {$fontHeadings}
          {$fontWeightHeadings}
        </div>
      </FormGroup>
      <FormGroup spacing="mb-0">
        <Label>{$format('label.BRAND_FONT_BASE')}</Label>
        <div style="font-family: {$fontBase}; font-size: 1.25rem; font-weight: {$fontWeightBase}">
          {$fontBase}
          {$fontWeightBase}
        </div>
      </FormGroup>
    </div>
  </CardBody>
</Card>
<h5 class="text-muted">{$format('label.BRAND_WIZARD_STEP_LOGOS')}</h5>

<Card class="mb-3">
  <CardBody>
    <div class="d-flex align-items-center flex-wrap gap-3">
      <FormGroup spacing="mb-0">
        <Label>{$format('label.LOGO')}</Label>
        <div>
          <div class="preview">
            <img src={$logoUrl} alt={$format('label.LOGO')} />
          </div>
        </div>
      </FormGroup>
      <FormGroup spacing="mb-0">
        <Label>{$format('label.ICON')}</Label>
        <div>
          <div class="preview">
            <img src={$iconUrl} alt={$format('label.ICON')} />
          </div>
        </div>
      </FormGroup>
    </div>
  </CardBody>
</Card>

<style lang="scss" src="./review.scss"></style>
